import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import ModalMC from '../../../../components/ModalMC';
import ButtonComponent from '../../../../components/ButtonMC';
import DocumentImage from 'images/chatbot_ai/ai_upgrade_plan.png';
import TitleMC from '../../../../components/TitleMC';
import customHistory from '../../../../../customHistory';
import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';

const CardComponent = ({
  title,
  imageSrc,
  imageAlt,
  description,
  buttonText,
  onPress,
  variant = 'PRIMARY',
  outlined = false
}) => (
  <div className="tw-w-full tw-p-8 tw-flex tw-flex-col tw-justify-between tw-items-center tw-gap-4 tw-min-h-full">
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-flex-grow">
      <div className="tw-w-[200px]">
        <img src={imageSrc} alt={imageAlt} />
      </div>
      <TitleMC textClassName="tw-w-full tw-text-center tw-text-base" text={title} variant='H1_SEMIBOLD' />
      <div className="tw-w-full tw-h-auto tw-text-center tw-text-xs">
        {description}
      </div>
    </div>
    <ButtonComponent
      text={buttonText}
      onClick={onPress}
      className="tw-text-sm !tw-px-8"
      variant={variant}
      outlined={outlined}
    />
  </div>
);

const UpgradePlanModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChatbotIA');
  const { retailer_info } = useSelector((reduxState) => reduxState.retailerUsersReducer);
  const { slug, chargebee_plan_id, chargebee_subscription_id, mia_onboarding_completed, onboarding_code } = retailer_info || {};
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const goPlans = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
    if (chargebee_plan_id || chargebee_subscription_id) {
      customHistory.push(`/retailers/${slug}/plans/${chargebee_plan_id}`);
    } else {
      customHistory.push(`/retailers/${slug}/plans`);
    }
  };
  useEffect(() => {
    if (mia_onboarding_completed && onboarding_code === 'used') {
      setTitle(t('upgrade.title_1'));
      setDescription(t('upgrade.description_1'));
    } else {
      setTitle(t('upgrade.title_2'));
      setDescription(t('upgrade.description_2'));
    }
  }, []);
  return (
    <ModalMC
      visible={isOpen}
      onClose={onClose}
      containerClassName="!tw-max-w-2xl !tw-z-[10003] !tw-mx-auto !tw-my-0 !tw-fixed !tw-top-1/2 !tw-left-1/2 !tw-transform !-tw-translate-x-1/2 !-tw-translate-y-1/2"
      overlayClassName="!tw-fixed !tw-inset-0 !tw-z-[10003] !tw-bg-black/50 !tw-backdrop-blur-sm"
      className="tw-px-8 tw-pb-14 tw-pt-8"
    >
      <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4">
        <CardComponent
          title={title}
          imageSrc={DocumentImage}
          imageAlt={title}
          description={description}
          buttonText={t('upgrade.button')}
          onPress={goPlans}
        />
      </div>
    </ModalMC>
  );
};

export default UpgradePlanModal;
